module.exports = __webpack_public_path__ + "static/media/adesivo_corujao.795671bd.png";